import sendEventToPiano from './send_event_to_piano';

export default class AtInternetManagingManager {
  static sendExportManagerEvent() {
    sendEventToPiano('click.action', { 'click': 'click export_manager' });
  }

  static sendEditManagerEvent() {
    sendEventToPiano('click.action', { 'click': 'click modifier_manager' });
  }

  static sendDeleteManagerEvent() {
    sendEventToPiano('click.action', { 'click': 'click validation_suppression_manager' });
  }

  static sendAddManagerEvent() {
    sendEventToPiano('click.action', { 'click': 'click ajout_manager' });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/at_internet/managing_manager.js